'use client';

import TitleMain from '@/components/shared/TitleMain/TitleMain';

const MainGraph = ({ mainGraphProps }) => {
  const {
    totalContributions2025,
    maxStreak2025,
    contributions2025,
    totalContributions2024,
    maxStreak2024,
    contributions2024,
    renderStreakBadge,
    renderGraph,
  } = mainGraphProps;
  return (
    <div className='overflow-x-auto bg-gradient-to-b from-purple-800 via-purple-800 to-purple-800 pt-10 pb-10 hidden lg:block'>
      <TitleMain text={`My Github contributions`} />
      <div className='container mx-auto'>
        {renderStreakBadge(totalContributions2025, maxStreak2025, 2025)}

        {renderGraph(contributions2025)}

        {renderStreakBadge(totalContributions2024, maxStreak2024, 2024)}

        {renderGraph(contributions2024)}
      </div>
    </div>
  );
};

export default MainGraph;
